export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:3000";
export const CLIENT_BASE_URL = import.meta.env.VITE_CLIENT_BASE_URL || "http://localhost:5173";
